export const BOARD_USER_ROLES = [
  { label: "Board Admin", value: "Board Admin" },
  { label: "User", value: "User" },
];

const isBoardAdmin = (role) => role === "Board Admin";

export const getRoleFromUser = (user) =>
  user?.is_admin ? "Board Admin" : "User";

export const buildPermissionValues = ({
  selectedRole,
  currentUser,
  isUpdateUser,
}) => ({
  can_create_task:
    isBoardAdmin(selectedRole) || currentUser?.can_create_task || !isUpdateUser,
  can_edit_task:
    isBoardAdmin(selectedRole) || currentUser?.can_edit_task || !isUpdateUser,
  can_delete_card: isBoardAdmin(selectedRole) || currentUser?.can_delete_card,
  can_reassign_user:
    isBoardAdmin(selectedRole) ||
    currentUser?.can_reassign_user ||
    !isUpdateUser,
  can_work_before_estimation:
    isBoardAdmin(selectedRole) ||
    currentUser?.can_work_before_estimation ||
    !isUpdateUser,
  can_update_status:
    isBoardAdmin(selectedRole) || currentUser?.can_update_status || !isUpdateUser,
  can_add_work_log:
    isBoardAdmin(selectedRole) || currentUser?.can_add_work_log || !isUpdateUser,
  can_edit_work_log:
    isBoardAdmin(selectedRole) || currentUser?.can_edit_work_log || !isUpdateUser,
  can_delete_work_log:
    isBoardAdmin(selectedRole) || currentUser?.can_delete_work_log,
  can_move_edit_work_log:
    isBoardAdmin(selectedRole) || currentUser?.can_move_edit_work_log,
  can_add_user: isBoardAdmin(selectedRole),
  can_change_milestone: isBoardAdmin(selectedRole),
});

export const getFormDefaultValues = ({
  boardId,
  currentUser,
  selectedRole,
  isColabrotar,
  isUpdateUser,
}) => ({
  board_id: boardId,
  user_id: currentUser?.user_id,
  user_role: selectedRole,
  ...(isColabrotar
    ? {}
    : buildPermissionValues({
        selectedRole,
        currentUser,
        isUpdateUser,
      })),
});

export const getActiveUserOptions = (usersData = []) =>
  usersData
    .filter((user) => user.active)
    .sort((a, b) => a.first_name.localeCompare(b.first_name))
    .map((user) => ({
      label: `${user.first_name} ${user.last_name} (${user.email})`,
      value: user.user_id,
    }));
